import locale_de_de from './locale_de_de';
import locale_en_us from './locale_en_us';

let locales = {
    de_de: locale_de_de,
    en_us: locale_en_us
};

export default locales;
